"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrientation = void 0;
const react_1 = require("react");
const useOrientation = (isActive) => {
    const [screenOrientation, setScreenOrientation] = (0, react_1.useState)();
    const handleWindowResize = (0, react_1.useCallback)(() => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        // eslint-disable-next-line no-nested-ternary
        setScreenOrientation(!isActive ? undefined : width > height ? 'horizontal' : 'vertical');
    }, [isActive]);
    (0, react_1.useEffect)(() => {
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [handleWindowResize, isActive]);
    return screenOrientation;
};
exports.useOrientation = useOrientation;
